<template>
  <div class="protected-page">
    <div class="welcome">Welcome to Pixie Apps Property Management V2</div>
    <div class="content-container">
      <div class="tile-container">
        <router-link to="/main">
          <div class="tile bank-ledger">
            <div class="tile-link">Bank and Ledger</div>
          </div>
        </router-link>
        <router-link to="/people">
          <div class="tile tenant-management">
            <div class="tile-link">Manage Tenants</div>
          </div>
        </router-link>
        <router-link to="/properties">
          <div class="tile manage-properties">
            <div class="tile-link">Manage Properties</div>
          </div>
        </router-link>
        <router-link to="/documents">
          <div class="tile manage-documents">
            <div class="tile-link">Manage Documents</div>
          </div>
        </router-link>
        <router-link to="/main">
          <div class="tile work-orders">
            <div class="tile-link">Work Orders</div>
          </div>
        </router-link>
        <router-link to="/lease-search">
          <div class="tile manage-leases">
            <div class="tile-link">Manage Leases</div>
          </div>
        </router-link>
        <router-link to="/reports">
          <div class="tile reports-charts">
            <div class="tile-link">Reports and Charts</div>
          </div>
        </router-link>
        <router-link to="/tools">
          <div class="tile settings-logs">
            <div class="tile-link">Settings, Utils, Logs</div>
          </div>
        </router-link>
        <div class="tile logout" @click="logout">
          <div class="tile-link">Goodbye Fren (Logout)</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axiosConfig';
import { clearStaffSession } from '@/utils/staffLogout';

export default {
  name: 'HomePage',
  components: {},
  created() {
    document.title = 'Home';
  },
  methods: {
    logout() {
      const token = localStorage.getItem('token');
      if (token) {
        axios
          .post('/api/logout', null, {
            headers: { Authorization: `Bearer ${token}` },
            skipGlobalError: true,
            timeout: 8000,
          })
          .catch(() => {});
      }
      clearStaffSession(localStorage, sessionStorage);
      delete axios.defaults.headers.common['Authorization'];
      this.$router.replace({ path: '/login', query: { loggedOut: '1' } });
    },
  },
  mounted() {
    // Check if the viewport width is less than 500px
    if (window.innerWidth < 500) {
      // Redirect to /mhome
      window.location.href = '/mhome';
    }
  },
};
</script>

<style scoped>
.protected-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  min-height: 80vh;
  padding: 0;
  box-sizing: border-box;
}

.nav-bar {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
}

.content-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
}

.tile-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 90%;
  grid-gap: 10px;
  padding: 10px;
}

.tile {
  background-color: #f5f5f5;
  border: 1px solid #4d4d4d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  height: 230px; /* Adjust as needed */
  position: relative;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Horizontal, Vertical, Blur Radius, Spread Radius, Color */
}

.tile a {
  text-decoration: none;
}

.tile img {
  max-width: 100%;
  max-height: 80%; /* Ensure the image fits well within the tile */
}

.tile span {
  margin-top: 5px;
  font-size: 14px;
  color: #800080; /* Match the color scheme */
}

.tile.bank-ledger {
  background:
    linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),
    url('/public/compressed/Bank_and_Ledger.jpg');
  background-size: 330px 220px; /* Ensure the image covers the div */
  background-position: center;
}

.tile.tenant-management {
  background:
    linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),
    url('/public/compressed/tenant_management.jpg');
  background-size: 330px 220px; /* Ensure the image covers the div */
  background-position: center;
}

.tile.logout {
  background:
    linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),
    url('/public/compressed/logo.jpg');
  background-size: 330px 220px; /* Ensure the image covers the div */
  background-position: center;
}

.tile.reports-charts {
  background:
    linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),
    url('/public/compressed/Reports_and_charts.jpg');
  background-size: 330px 220px; /* Ensure the image covers the div */
  background-position: center;
}

.tile.manage-properties {
  background:
    linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),
    url('/public/compressed/Manage_properties.jpg');
  background-size: 330px 230px; /* Ensure the image covers the div */
  background-position: center;
}
.tile.manage-documents {
  background:
    linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),
    url('/public/compressed/document_manager.jpg');
  background-size: 330px 220px; /* Ensure the image covers the div */
  background-position: center;
}

.tile.work-orders {
  background:
    linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),
    url('/public/compressed/work-orders.jpg');
  background-size: 330px 220px; /* Ensure the image covers the div */
  background-position: center;
}

.tile.manage-leases {
  background:
    linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),
    url('/public/compressed/manage-leases.jpg');
  background-size: 330px 220px; /* Ensure the image covers the div */
  background-position: center;
}
.tile.settings-logs {
  background:
    linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),
    url('/public/compressed/settings_logs.jpg');
  background-size: 360px 230px; /* Ensure the image covers the div */
  background-position: center;
}

.tile-link {
  width: 100%;
  height: 30px;
  color: white;
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 9px 0px 0px;
  font-size: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
}

.welcome {
  margin-top: 55px;
  font-size: 24pt;
  width: 960px;
  padding: 10px;
  text-align: center;
  color: white;
  background: #46345c;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Horizontal, Vertical, Blur Radius, Spread Radius, Color */
}
</style>
